/* ExportSummaryComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;

const Renderer = require("./ExportSummaryRenderer");

class ExportSummaryComponent extends EventEmitter {
    constructor(errors, logger) {
        super();
        this._errors = errors;
        this._logger = logger;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._errors = undefined;
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ExportSummaryComponent.shutdown() error.");
            }
        );
    }

    sendOk() {
        this._context.resolve({});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    getErrors() {
        return this._errors;
    }

    get errors() {
        return this.getErrors();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /*******************************************/
}
module.exports = ExportSummaryComponent;
